//https://tom-select.js.org/
import TomSelect from "tom-select";
import "tom-select/dist/css/tom-select.default.min.css";

window.addEventListener('load', function () {
    //Recherche multiple (autocomplete)
    let autocompleteMultipleElements = document.querySelectorAll('.js-autocomplete-multiple');

    if (autocompleteMultipleElements != null && autocompleteMultipleElements.length > 0) {
        autocompleteMultipleElements.forEach(function (autocompleteMultipleElement) {
            let maxReponses = 30;
            if (autocompleteMultipleElement.getAttribute('data-max-reponse') != null) {
                maxReponses = autocompleteMultipleElement.getAttribute('data-max-reponse');
            }
            //Créer l'autocomplete
            new TomSelect(autocompleteMultipleElement, {
                maxItems: maxReponses,
                render: {
                    no_results: function (data, escape) {
                        return '<div class="no-results">Aucun résultat trouvé</div>';
                    },
                },
                plugins: {
                    remove_button:{
                        title:'Retirer',
                    }
                },
            });
        });
    }
});